import {appConfigService} from '_app/services';
import {sectionConstants} from '_app/utils';

const getMediaSections = () => {
	const sections = [];
	const isCampaignsEnabled = appConfigService.get('allowCampaign');

	if (isCampaignsEnabled) {
		sections.push({
			id: sectionConstants.SECTION_IDS.CAMPAIGNS_ID,
			value: sectionConstants.SECTION_IDS.CAMPAIGNS_ID,
			name: sectionConstants.SECTION_NAMES.campaigns,
			description: sectionConstants.DESCRIPTIONS.CAMPAIGNS,
			defaultCategory: sectionConstants.DEFAULT_CATEGORIES.FEATURED
		});
	}

	sections.push({
		id: sectionConstants.SECTION_IDS.CONTENT_LIBRARY_ID,
		value: sectionConstants.SECTION_IDS.CONTENT_LIBRARY_ID,
		name: sectionConstants.SECTION_NAMES.contentLibrary,
		description: sectionConstants.DESCRIPTIONS.CONTENT_LIBRARY,
		defaultCategory: sectionConstants.DEFAULT_CATEGORIES.ALL_CATEGORIES
	});

	if (appConfigService.get('allowEmail')) {
		sections.push({
			id: sectionConstants.SECTION_IDS.EMAILS_ID,
			value: sectionConstants.SECTION_IDS.EMAILS_ID,
			name: sectionConstants.SECTION_NAMES.emails,
			description: sectionConstants.DESCRIPTIONS.EMAILS,
			defaultCategory: sectionConstants.DEFAULT_CATEGORIES.ALL_CATEGORIES
		});
	}

	return sections;
};

const getMediaSectionsWithAllSection = () => {
	const sections = getMediaSections();

	sections.unshift({
		value: 0,
		id: 0,
		name: 'All Sections'
	});

	return sections;
};

const getSectionsWithoutCampaigns = () => {
	return getMediaSections().filter(section => section.id !== sectionConstants.SECTION_IDS.CAMPAIGNS_ID);
};

const getDefaultSection = () => {
	const isCampaignsEnabled = appConfigService.get('allowCampaign');

	return isCampaignsEnabled ? sectionConstants.SECTION_IDS.CAMPAIGNS_ID : sectionConstants.SECTION_IDS.CONTENT_LIBRARY_ID;
};

export default {
	getMediaSections,
	getMediaSectionsWithAllSection,
	getSectionsWithoutCampaigns,
	getDefaultSection
};